import { Injectable } from '@angular/core';
import { HttpService } from './HttpClientServices/Http.service';

@Injectable({
  providedIn: 'root'
})
export class ErpawareCheckService {
  
  public erpawarePermission: boolean = false;

  constructor(
    private _HttpService: HttpService
  ) { }

  public checkErpawarePermission(URL: string) {
    this._HttpService.getParamList(['2001']).subscribe(res => {
      if (res?.value[0].PARAM_VALUE !== '0') this.checkErpaware(URL);
      else { 
        this.erpawarePermission = true; 
        this.setDataToLocalStorage(URL);
      }
    });
  }

  private checkErpaware(URL: string) {

      const APIURL = `checkErpaware?IsErpAware=1&ScreenPath=${URL}`
      this._HttpService.get(APIURL).subscribe(res => {
        this.erpawarePermission = (res?.length > 0) ? (res[0].EnableEditOnERPIntegration === 1) : true;
        this.setDataToLocalStorage(res[0]?.KeyID);
      })
  }

  private setDataToLocalStorage(keyId) {
    localStorage.setItem('erpawarePermission', JSON.stringify({SK: keyId, permission: this.erpawarePermission }))
  }
}
